import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fluxOfIdeasActions } from '../../../actions';

export function useMyIdeasController() {
  const dispatch = useDispatch();
  const { ideasStepsFlux } = useSelector(state => state.domains);
  const { ideasFlux, paging, loadingFlux } = useSelector((state) => state.fluxIdeas);

  useEffect(() => {
    dispatch(fluxOfIdeasActions.getIdeasUserStepFlux(
      paging.page,
      paging.sort,
      paging.query,
      paging.limit,
      ideasStepsFlux.map(({ _id }) => _id)
    ));
  }, [dispatch]);

  function loadMoreIdeas() {
    if (!loadingFlux) {
      var newPage = pagingDefault.page === 1 ? 2 : pagingDefault.page;

      dispatch(fluxOfIdeasActions.getIdeasUserStepFlux(
        newPage,
        paging.sort,
        paging.query,
        paging.limit,
        ideasStepsFlux.map(({ _id }) => _id)
      ));
    }
  }

  function searchIdea(query) {
    dispatch(fluxOfIdeasActions.getIdeasUserStepFlux(
      paging.page,
      paging.sort,
      query,
      paging.limit,
      ideasStepsFlux.map(({ _id }) => _id)
    ));
  }

  return {
    loadMoreIdeas,
    searchIdea,
    ideas: ideasFlux,
    loading: loadingFlux,
    paging
  }
}